import Footer, { Props } from "./Footer";

export default Footer;
export type { Props };
